import { useIssue442AbTestStore } from '@/store/ab_test_issue_442'
import { ISSUE_442_AB_TEST_CONFIG } from '@/utils/abtest/abTestConfig'
import useABTestV2 from '@/utils/abtest/useABTestV2'
import GTM from '@/utils/tracking/gtm'

type ABGroup = 'A' | 'B' | ''

type Issue442AbTestComposable = {
  initialize: () => void
  sendOnPageView: () => void
  sendOnItemClick: () => void
}

const EVENT_CATEGORY = 'issue442'

export function useIssue442AbTest(): Issue442AbTestComposable {
  const store = useIssue442AbTestStore()

  const initialize = () => {
    store.abTestResult = useABTestV2(ISSUE_442_AB_TEST_CONFIG)
  }

  const abGroup = computed<ABGroup>(() => {
    const result = store.abTestResult
    if (!result) return ''
    if (result.isAPattern) return 'A'
    if (result.isBPattern) return 'B'
    return ''
  })
  const isActive = computed(() => abGroup.value !== '')

  const sendOnPageView = () => {
    if (!isActive.value || import.meta.server) return
    GTM.sendEventToGa({
      category: EVENT_CATEGORY,
      action: 'list_view',
      label: abGroup.value
    })
  }

  const sendOnItemClick = () => {
    if (!isActive.value || import.meta.server) return
    GTM.sendEventToGa({
      category: EVENT_CATEGORY,
      action: 'event_click',
      label: abGroup.value
    })
  }

  return {
    initialize,
    sendOnPageView,
    sendOnItemClick
  }
}
